import { useQuery } from "@tanstack/react-query"
import { api } from "@/lib/api"
import type { PaperCard } from "@/types/api"
import { PaperCardItem } from "@/components/papers/PaperCard"

export default function HomePage() {
  const { data, isLoading, error } = useQuery({
    queryKey: ["papers", { window: "30d", sort: "hot", limit: 15 }],
    queryFn: () =>
      api.get<PaperCard[]>(`/papers?window=30d&sort=hot&limit=15`),
  })

  return (
    <div>
      <header className="mb-6">
        <h1 className="text-2xl font-semibold tracking-tight">오늘의 Hot Papers</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          최근 30일, hotness score 기준 상위 15편
        </p>
      </header>
      {isLoading && <div className="text-sm text-muted-foreground">불러오는 중...</div>}
      {error && (
        <div className="rounded-md border border-destructive/30 bg-destructive/5 p-4 text-sm text-destructive">
          불러올 수 없습니다: {(error as Error).message}
        </div>
      )}
      <div className="space-y-3">
        {data?.map((p) => <PaperCardItem key={p.id} paper={p} />)}
        {data && data.length === 0 && (
          <div className="rounded-md border border-border p-6 text-center text-sm text-muted-foreground">
            논문이 아직 없습니다.
          </div>
        )}
      </div>
    </div>
  )
}
